const APIBaseUrl = process.env.REACT_APP_API_URL
const APIBaseUrlToken = APIBaseUrl + 'token'
const APIBaseUrlEndpoints = APIBaseUrl + 'api/'
const AuthorizationserverTokenUrl = process.env.REACT_APP_AUTHORIZATIONSERVER_URL + 'token'


export const APIEndpoints = {
  settings: () => {
    const firstPart = 'settings/page'
    return {
      dashboard: `${firstPart}/dashboard`,
      businesspartnerData: `${firstPart}/businesspartnerData`,
      personalOrder: `${firstPart}/personalOrder`
    }
  },
  coreservices: () => ({
    stdPointRun: 'coreservices/stdPointRun/status',
    pointRunConfig: 'coreservices/stdPointRun/configuration',
    ooReqGenerator: 'coreservices/ooReqGenerator/status',
  }),
  checkDocumentUpload: 'settings/check/documentUpload',
  orderDetails: '/settings/page/orderDetails',
  shoppingCartTunnel: '/settings/page/shoppingCartTunnel',
  partialCostCenters: 'partialCostCenters',
  partialCostCenter: costCenterId => `partialCostCenters/${costCenterId}`,
  balanceChangeReasons: 'balanceChangeReasons',
  reorders: orderId => `shoppingBaskets/reorders/${orderId}`,
  articleCatalogs: basketId => `shoppingBaskets/${basketId}/articleCatalogs`,
  defaultArticleCatalog: '/articleCatalogs/default',
  defaultArticleCatalogArticles: (articleCatalogId, limit, offset) => `/articleCatalogs/${articleCatalogId}/articles?page.limit=${limit}&page.offset=${offset}`,
  defaultArticleCatalogArticle: (catalogId, articleId) => `articleCatalogs/${catalogId}/articles/${articleId}`,
  externalCatalogs: articleCatalogId => `externalCatalogs/${articleCatalogId}`,
  articleBarcodes: catalogId => `articleCatalogs/${catalogId}/reports/articleBarcodes`,
  articleCatalogCategories: articleCatalogId => `articleCatalogs/${articleCatalogId}/articleCatalogCategories`,
  searchCriteriaCatalogCategories: articleCatalogId => `articleCatalogs/${articleCatalogId}/searchCriteriaCatalogCategories`,
  orderableArticles: (basketId, limit, offset) => `shoppingBaskets/${basketId}/orderableArticles?page.limit=${limit}&page.offset=${offset}`,
  profile: 'profile',
  resetPassword: 'resetPassword',
  newPassword: 'newPassword',
  loginQuestion: 'loginQuestion',
  changePassword: 'changePassword',
  passwordRules: 'passwordRules',
  securityQuestions: 'securityQuestions',
  search: searchtext => `search?searchtext=${searchtext}`,
  businessPartners: 'businessPartners',
  businessPartner: (partnerId, id) => {
    const firstPart = `businessPartners/${partnerId}`
    return {
      patch: firstPart,
      info: `${firstPart}/info`,
      mainData: `${firstPart}/maindata`,
      communicationData: `${firstPart}/communicationData`,
      addresses: `${firstPart}/addresses`,
      activities: `${firstPart}/activities`,
      shoppingActivities: `${firstPart}/shoppingActivities`,
      budgetBalances: `${firstPart}/budgetBalances`,
      checkUps: `${firstPart}/checkUps`,
      instances: `${firstPart}/instances`,
      currentQuarantineStatus: `${firstPart}/currentQuarantineStatus`,
      officeAdresses: `${firstPart}/officeAdresses`,
      articleConfigurations: `${firstPart}/articleConfigurations`,
      articleConfigurationsVariants: `${firstPart}/articleConfigurations/${id}/variants`,
      articleConfigurationsConfigurations: `${firstPart}/articleConfigurations/${id}/configurations`,
      articleComment: `${firstPart}/contingent/${id}/comment`,
      articleDetails: `${firstPart}/contingent/${id}/details`,
      articleHistories: `${firstPart}/contingent/${id}/histories`,
      articleInstances: `${firstPart}/contingent/${id}/instances`,
      activationStatus: `${firstPart}/activationStatus`,
      laundryShelves: `${firstPart}/laundryShelves`,
      inventoryBookings: `${firstPart}/contingent/inventoryBookings`,
      returnBookings: `${firstPart}/contingent/returnBookings`,
      articleTransfer: `${firstPart}/contingent/articleTransfer`,
      assetArticleTransfer: `${firstPart}/contingent/assetArticleTransfer`,
      assets: `${firstPart}/contingent/assets`,
      account: `${firstPart}/account`,
      inventorHistory: `${firstPart}/inventorHistory`,
      currentPoints: `${firstPart}/currentPoints`,
      contingent: `${firstPart}/contingent`,
      checkUp: `${firstPart}/checkUps/${id}`,
      checkUpDocuments: `${firstPart}/checkUps/${id}/documents`,
      documents: `${firstPart}/documents`,
      checkInventory: `${firstPart}/checkInventory`,
    }
  },
  bussinesspartnerInventoryScan: (partnerId)  => `businessPartners/${partnerId}/inventoryscan`,
  businesspartnerShoppingArticleAmounts: (partnerId, orderProcessType, shoppingBasketArticleId) => `businessPartners/${partnerId}/orders/${orderProcessType}/shoppingBasketArticles/${shoppingBasketArticleId}/amounts`,
  bussinesspartnerRFIDneutralization: (partnerId, articleContingentid, rfid)  => `businessPartners/${partnerId}/contingent/${articleContingentid}/instances/${rfid}/neutralizes`,
  shoppingBaskets: `shoppingBaskets`,
  acceptedShoppingBaskets: `shoppingBaskets/acceptedShoppingBaskets`,
  shoppingBasket: basketId => `shoppingBaskets/${basketId}`,
  shoppingBasketArticle: (basketId, shoppingBasketArticleId) => `shoppingBaskets/${basketId}/shoppingBasketArticles/${shoppingBasketArticleId}`,
  shoppingBasketArticleVariants: (basketId, shoppingBasketArticleId) => `shoppingBaskets/${basketId}/articles/${shoppingBasketArticleId}/orderableVariants`,
  shoppingBasketArticleConfigurations: (basketId, shoppingBasketArticleId) => `shoppingBaskets/${basketId}/articles/${shoppingBasketArticleId}/configuration`,
  shoppingBasketArticleNextExpiries: (basketId, shoppingBasketArticleId) => `shoppingBaskets/${basketId}/shoppingBasketArticles/${shoppingBasketArticleId}/nextExpiries`,
  shoppingBasketArticlePositionInstances: (basketId, shoppingBasketArticleId) => `shoppingBaskets/${basketId}/shoppingBasketArticles/${shoppingBasketArticleId}/positionInstances`,
  shoppingBasketArticlePositionInstancesForPosition: (basketId, shoppingBasketArticleId, positionId) => `shoppingBaskets/${basketId}/shoppingBasketArticles/${shoppingBasketArticleId}/position/${positionId}/instances`,
  shoppingBasketAvailabilities: basketId => `shoppingBaskets/${basketId}/availabilities`,
  shoppingBasketScan: (basketId, barcode) => `shoppingBaskets/${basketId}/scan/${barcode}/order`,
  orderableAccessories: (basketId, articleId) => `shoppingBaskets/${basketId}/articles/${articleId}/orderableAccessories`,
  addOrderableAccessories: (basketId, shoppingBasketArticleId) => `shoppingBaskets/${basketId}/shoppingBasketArticles/${shoppingBasketArticleId}/orderableAccessories`,
  variantQuantities: (basketId, aticleId) => `shoppingBaskets/${basketId}/articles/${aticleId}/variantQuantities`,
  localStorehouses: (basketId, aticleId) => `shoppingBaskets/${basketId}/articles/${aticleId}/localStorehouses`,
  lastComment: (basketId, aticleId) => `shoppingBaskets/${basketId}/articles/${aticleId}/lastComment`,
  prices: (basketId, aticleId) => `shoppingBaskets/${basketId}/articles/${aticleId}/prices`,
  orderableFollowerArticle: (basketId, aticleId) => `shoppingBaskets/${basketId}/articles/${aticleId}/orderableFollowerArticle`,
  orderablePredecessorArticles: (basketId, articleId) => `shoppingBaskets/${basketId}/articles/${articleId}/orderablePredecessorArticles`,
  productHistory: (basketId, aticleId) => `shoppingBaskets/${basketId}/articles/${aticleId}/orderHistory`,
  availableAddresses: basketId => `shoppingBaskets/${basketId}/availableAddresses`,
  availableCountries: basketId => `shoppingBaskets/${basketId}/availableCountries`,
  orderTemplates: basketId => `shoppingBaskets/${basketId}/orderTemplates`,
  orderInfo: basketId => `shoppingBaskets/${basketId}/orderInfo`,
  validator: basketId => `shoppingBaskets/${basketId}/validator`,

  shipmentTypes: basketId => {
    if (!basketId) {
      return 'shipmentTypes'
    }
    return `shoppingBaskets/${basketId}/shipmentTypes`
  },
  article: articleId => `articles/${articleId}`,
  articleScan: barcode => `articles/${barcode}/scan`,
  postArticleScan: `articles/scan`,
  articleVariants: articleId => `articles/${articleId}/variants`,
  articleEntitlementAssignments: articleId => `articles/${articleId}/entitlementAssignments`,
  articleCatalogAssingments: articleId => `articles/${articleId}/catalogAssignments`,
  articleGetFavorite: (articleId) => `articles/${articleId}/favorites`,
  articleSetFavorite: (articleId, remove) => `articles/${articleId}/favorites?remove=${remove}`,
  contingent: basketId => `/shoppingBaskets/${basketId}/contingent`,
  countries: 'countries',
  languages: 'languages',
  entitlementPhases: 'entitlementphases',
  incomingOrdersCounter: 'incomingOrdersCounter',
  incomingOrders: incomingOrderId => {
    const firstPart = incomingOrderId ? `incomingOrders/${incomingOrderId}` : 'incomingOrders'
    return {
      incomingOrder: firstPart,
      incomingOrderPositions: `${firstPart}/incomingOrderPositions`,
      changeIncomingOrderPositions: `${firstPart}/changeIncomingOrderPositions`,
      shippingOrders: `${firstPart}/shippingOrders`,
      incomingOrders: firstPart,
      releases: `${firstPart}/releases`,
      rejections: `${firstPart}/rejections`,
      groups: `${firstPart}/groups`,
      cancellations: `${firstPart}/cancellations`,
      groupReleases: `${firstPart}/groupReleases`,
      groupRejections: `${firstPart}/groupRejections`,
      srmCostCenters: `${firstPart}/srmOrders/costCenters`,
      srmCostCentersCounter: `${firstPart}/srmOrders/costCentersCounter`,
      supplierOrders: `${firstPart}/supplierOrders`,
      receipt: `${firstPart}/receipt`
    }
  },
  supplierOrders: incomingOrderId => {
    const firstPart = `supplierOrders/${incomingOrderId}`
    return {
      supplierOrder: firstPart,
      expectedArrivals: `${firstPart}/expectedArrivals`,
      supplierOrderPositions: `${firstPart}/supplierOrderPositions`
    }
  },
  placeholder: (id) => ({
    placeholders: 'administration/placeholders',
    placeholder: `administration/placeholders/${id}`,
    inheritance: `administration/inheritance/placeholders`,
    types: 'administration/types',
    type: `administration/types/${id}`,
    checkPlaceholders: `administration/types/${id}/checkPlaceholders`
  }
  ),

  laundryShelves: (id) => {
    const firstPart = 'laundryShelves'
    return id
      ? {
        locations: `${firstPart}/locations/${id}`,
        elements: `${firstPart}/elements/${id}`,
        levels: `${firstPart}/levels/${id}`
      }
      : {
        list: `${firstPart}/list`,
        tree: `${firstPart}/tree`,
        locations: `${firstPart}/locations`,
        levels: `${firstPart}/levels`
      }
  },

  changeShippingOrderPositions: shippingOrderId => `shippingOrders/${shippingOrderId}/changeShippingOrderPositions`,
  shippingOrderPositions: shippingOrderId => `shippingOrders/${shippingOrderId}/shippingOrderPositions`,
  shippingOrderPositionsReorderableVariants: shippingOrderId => `shippingOrderPositions/${shippingOrderId}/reorderableVariants`,
  returnReasons: `returnReasons`,
  infoTAT: shippingOrderId => `shippingOrders/${shippingOrderId}/infoTAT`,
  feeds: 'feeds',
  feedsAdministration: id => {
    return {
      feeds: 'administration/news',
      edit: `administration/news/${id}`,
      orderSequences: `administration/news/orderSequences`,
      fileUpload: `administration/news/${id}/fileUpload`
    }
  },
  logout: 'logout',
  registrations: mandator => {
    const firstPart = `registrations/${mandator}`
    return {
      registration: firstPart,
      countries: `${firstPart}/countries`
    }
  },
  partialBusinessPartners: 'partialBusinessPartners',
  partialOffices: 'partialOffices',
  partialOffice: officeId => `partialOffices/${officeId}`,
  partialShoppingBaskets: (status = 'isOpen') => `partialShoppingBaskets?filter.status=${status}`,
  currentInventory: (businesspartnerId, asExcel) => `businesspartnerReports/${businesspartnerId}/currentInventory?asExcel=${asExcel}`,
  budgethistory: businesspartnerId => `businesspartnerReports/${businesspartnerId}/budgethistory`,
  contingenthistory: businesspartnerId => `businesspartnerReports/${businesspartnerId}/contingenthistory`,
  allActivities: 'activities',
  businessPartnersWithMissingData: 'articleConfigurations/countBusinesspartnersWithMissingData',
  layoutTypeIsAvailable: layoutType => `layoutTypes/${layoutType}/check`,
  maintenanceReport: instanceId => `articleInstanceReports/${instanceId}/maintenance`,
  performMaintanance: instanceId => `articleInstances/${instanceId}/fastservice`,
  reportJobTypes: 'reportJobTypes',
  reportJobTypeGroups: 'reportJobTypeGroups',
  reportJobs: id => {
    if (!id) {
      return 'reportJobs'
    }
    const firstPart = `reportJobs/${id}`
    return {
      details: `${firstPart}`,
      subscriptions: `${firstPart}/subscriptions`
    }
  },
  cabinEventReport: 'cabinEventReport',
  reportJobsCounter: 'reportJobsCounter',
  statisticCostcenters: 'statisticCostcenters',
  statisticEmployeeList: 'statisticEmployeeList',
  statisticEmployeeHealthList: 'statisticEmployeeHealthList',
  statisticCostcentersFromOrders: 'statisticCostcentersFromOrders',
  turnOverStatisticsOnEntityUnit: 'turnOverStatisticsOnEntityUnit',
  statisticStockChanges: 'statisticStockChanges',
  statisticDispoList: 'statisticDispoList',
  statisticInventoryListByArticle: 'statisticInventoryListByArticle',
  openReportJobs: 'openReportJobs',
  statisticEmployeeInventory: 'statisticEmployeeInventory',
  statisticAssetInventory: 'statisticAssetInventory',
  statisticArticleInstanceExpiries: 'statisticArticleInstanceExpiries',
  statisticArticleInstanceServiceInterval: 'statisticArticleInstanceServiceInterval',
  statisticArticleInstanceExpiringWarranties: 'statisticArticleInstanceExpiringWarranties',
  statisticPerformedServicejobs: 'statisticPerformedServicejobs',

  statisticOverTimePeriod: 'wash/reports/statisticOverTimePeriod',
  statisticForSingleRFID: 'wash/reports/statisticForSingleRFID',
  statisticSortedOutRFIDs: 'wash/reports/statisticSortedOutRFIDs',
  statisticPartsInWashingProcess: 'wash/reports/statisticPartsInWashingProcess',
  statisticRFIDs: 'statisticRFIDs',

  businesspartnerCheckUpTypes: 'businesspartnerCheckUpTypes',
  businesspartnerCheckUpConfigs: 'businesspartnerCheckUpConfigs',
  appointmenttypes: appointmentTypeId => {
    if (!appointmentTypeId) {
      return 'appointmenttypes'
    }
    const firstPart = `appointmenttypes/${appointmentTypeId}`
    return {
      default: firstPart,
      deletable: `${firstPart}/deletable`,
      appointmenttypeData: `${firstPart}/appointmenttypeData`,
      assignedCabins: `${firstPart}/assignedCabins`,
      timeSlots: `${firstPart}/timeSlots`,
      timeSlotsAdministration: `${firstPart}/timeSlots/administration`,
      cabins: `${firstPart}/cabins`,
      bookableTimeSlots: (cabinId, date) => `${firstPart}/cabins/${cabinId}/bookableTimeSlots/${date}`,
      appointmentOverviews: (cabinId) => `${firstPart}/cabins/${cabinId}/appointmentOverviews`,
    }
  },
  cabins: id => {
    if (!id) {
      return 'cabins'
    }
    const firstPart = `cabins/${id}`;
    return {
      details: `${firstPart}`,
      cabinData: `${firstPart}/cabinData`,
      deletable: `${firstPart}/deletable`,
      assignedAppointmenttypes: `${firstPart}/assignedAppointmenttypes`,
      events: `${firstPart}/events`,
      locks: `${firstPart}/locks`,
      groupReservations: `${firstPart}/groupReservations`,
    }
  },
  appointments: 'appointments',
  bookingOverview: 'appointments/bookingOverview',
  appointment: id => `appointments/${id}`,
  costCenters: id => {
    const firstPart = `costCenters/${id}`;
    return {
      details: `${firstPart}`,
      groupAssignments: `${firstPart}/groupAssignments`,
      interfaces: `${firstPart}/interfaces`
    }
  },
  newCostCenters: "costCenters",
  costCenterTypes: "costCenterTypes",
  offices: (id, addressId) => {
    return {
      details: `offices/${id}`,
      groupAssignments: `offices/${id}/groupAssignments`,
      addresses: `offices/${id}/addresses`,
      availableAddressTypes: `offices/${id}/availableAddressTypes`,
      deleteAddress: `offices/${id}/addresses/${addressId}`,
      patchAddress: `offices/${id}/addresses/${addressId}`
    }
  },
  newOffices: "offices",
  customHtmlMenu: 'customHTML/menu',
  customHtmlPage: id => `customHTML/page/${id}`,
  customFooter: 'customHTML/footer',
  customContact: 'customHTML/contact',
  customHTMLVideo: placeholder => `customHTML/video/${placeholder}`,
  officeExport: "officeExport",
  officeImport: "officeImport",
  entitlementImport: "entitlementImport",
  entitlementExport: "entitlementExport",
  costcenterExport: "costcenterExport",
  costcenterImport: "costcenterImport",
  orderExport: "orderExport",
  orderImport: "orderImport",
  srmOrderExport: "srmOrderExport",
  catalogImport: "catalogImport",
  articleImport: "articleImport",
  articleExport: "articleExport",
  paymentStatus: id => `paymentProviders/shoppingbaskets/paymentStatus?id=${id}`,
  linksRlx: "links/rlx",
  privateOrderSwitchToSubmandator: mandatorId => `links/privateOrders?mandatorId=${mandatorId}`,
  groups: "groups",
  accounts: id => {
    return {
      accessibleCostcenters: `accounts/${id}/costcenters`,
      accessibleOffices: `accounts/${id}/offices`,
      accessibleCatalogs: `accounts/${id}/catalogs`,
      assignedGroups: `accounts/${id}/groups`,
      accessibleLocations: `accounts/${id}/locations`,
      accessibleStorehouses: `accounts/${id}/storehouses`
    }
  },
  returns: id => ({
    details: `returns/${id}`,
    receipt: `returns/${id}/receipt`,
    overview: 'returns/overview',
    messages: `returns/${id}/messages`,
    positions: `returns/${id}/positions`,
    contactData: `returns/${id}/contactData`
  }),
  incomingOrder: id => ({
    returns: `incomingOrder/${id}/returns`,
    complaintsContactData: `incomingOrder/${id}/complaintsContactData`,
    complaints: `incomingOrder/${id}/complaints`,
    returnsContactData: `incomingOrder/${id}/returnsContactData`
  }),
  accessibleArticleCatalogs: "articleCatalogs",
  complaints: id => {
    const firstPart = `complaints/${id}`
    return {
      default: firstPart,
      convertToReturn: `${firstPart}/convertToReturn`,
      receipt: `${firstPart}/receipt`,
      messages: `${firstPart}/messages`,
      close: `${firstPart}/close`,
      reopen: `${firstPart}/reopen`,
      activate: `${firstPart}/activate`
    }
  },
  complaintsFile: (complaintId, messageId) => `complaints/${complaintId}/messages/${messageId}/fileUpload`,
  pointsChangesCounter: 'pointsChangeRequest/counter',
  pointsChangeRequest: {
    get: 'pointsChangeRequest',
    cancellations: 'pointsChangeRequest/cancellations',
    releases: 'pointsChangeRequest/releases',
    rejections: 'pointsChangeRequest/rejections',
    counter: 'pointsChangeRequest/counter'
  },
  inventoryChangeRequest: id => ({
    get: 'inventoryChangeRequest',
    cancellations: 'inventoryChangeRequest/cancellations',
    releases: 'inventoryChangeRequest/releases',
    rejections: 'inventoryChangeRequest/rejections',
    counter: 'inventoryChangeRequest/counter',
    pictureUpload: `inventoryChangeRequest/${id}/pictureUpload`
  }),
  paiOrders: id => ({
    get: 'paiOrders',
    releases: 'paiOrders/releases',
    rejections: 'paiOrders/rejections',
    counter: 'paiOrders/counter',
    receipt: `supplierOrders/${id}/receipt`
  }),
  shippingOrders: id => ({
    getSignature: `shippingOrders/${id}/wasPickedUp/signature`,
    setSignature: `shippingOrders/${id}/wasPickedUp`,
  }),
  inventoryBookingReasons: 'inventoryBookingReasons',
  returnBookingReasons: 'returnBookingReasons',
  administration: id => ({
    postActivity: `administration/activities`,
    activities: `administration/activities/${id}`,
    activitiesOrderSequences: `administration/activities/ordersequences`,
    entitlementPhase: `administration/entitlementphases/${id}`,
    postEntitlementPhase: `administration/entitlementphases`,
    entitlementPhasesOrderSequences: `administration/entitlementphases/ordersequences`,
    contingentTemplates: 'entitlements',
    contingentTemplatesOrderSequences: `administration/entitlements/ordersequences`,
    catalogs: `administration/articleCatalogs`,
    catalogsOrderSequences: `administration/articleCatalogs/ordersequences`,
    assetType: `administration/assettypes/${id}`,
    assetTypes: `administration/assettypes`,
    assetTypeAssignedActivities: `administration/assettypes/${id}/activities`,
  }),
  assetTypes: 'assettypes',
  articles: 'articles',
  contingentTemplate: (id, groupId, articleId) => ({
    create: 'administration/entitlements',
    delete: `administration/entitlements/${id}`,
    edit: `administration/entitlements/${id}`,
    copy: `administration/entitlements/${id}/copy`,
    pictureUpload: `administration/entitlements/${id}/pictureUpload`,
    picture: `administration/entitlements/${id}/picture`,
    groups: `administration/entitlements/${id}/groups`,
    groupsOrderSequences: `administration/entitlements/${id}/groups/ordersequences`,
    group: `administration/entitlements/${id}/groups/${groupId}`,
    createGroup: `administration/entitlements/${id}/groups`,
    groupPicture: `administration/entitlements/${id}/groups/${groupId}/picture`,
    groupPictureUpload: `administration/entitlements/${id}/groups/${groupId}/pictureUpload`,
    groupArticles: `administration/entitlements/${id}/groups/${groupId}/articles`,
    groupArticlesOrderSequences: `administration/entitlements/${id}/groups/${groupId}/articles/ordersequences`,
    groupArticle: `administration/entitlements/${id}/groups/${groupId}/articles/${articleId}`
  }),
  catalogs: (id, elementId, articleId) => ({
    catalog: `administration/articleCatalogs/${id}`,  // GET, PATCH, DELETE 
    officeAvailabilities: `administration/articleCatalogs/${id}/officeAvailabilities`,  // POST, DELETE 
    structures: `administration/articleCatalogs/${id}/structures`,
    structureOrderSequence: `administration/articleCatalogs/${id}/structures/ordersequences`,
    structureArticles: `administration/articleCatalogs/${id}/structures/${elementId}/articleAssignments`,
    catalogArticles: `administration/articleCatalogs/${id}/articleAssignments`,
    dimension: `administration/articleCatalogs/${id}/structures/${elementId}`,
    createDimension: `administration/articleCatalogs/${id}/structures`,
    deleteStructureArticle: `administration/articleCatalogs/${id}/structures/${elementId}/articleAssignments/${articleId}`,
    deleteCatalogArticle: `administration/articleCatalogs/${id}/articleAssignments/${articleId}`
  }),
  orderProcessTypes: 'orderProcessTypes',
  aliasTypes: 'aliasTypes',
  supplierMandators: 'supplierMandators',
  suppliers: 'suppliers',
  currentMandator: 'currentMandator',
  subMandators: 'subMandators',
  bills: 'bills',
  billingDetails: 'oac/reports/billingdetails',
  procurementGroups: 'procurementGroups',
  currencies:'currencies',
  priceLists:'priceLists',
  storehouseTree:'storehouseTree',
  storehouseTreeNode: (treeItemId, type) => `storehouseTree/${type}/${treeItemId}`,
  storehouses: storehouseId => {
    if (!storehouseId) {
      return 'storehouses'
    }
    const firstPart = `storehouses/${storehouseId}`;
    return {
      details: `${firstPart}`,
      costcenters: `${firstPart}/costcenters`,
    }
  },
  localstock: (id) => {
    const firstPart = `localstock`;
    return {
      localInventories: `${firstPart}/inventories`,
      localInventory: `${firstPart}/inventory`,
      instance: `${firstPart}/instance`,
      recommandations: `${firstPart}/recommandations`,
    }
  },
  localGoodsReceipts: (id, actionMode) => {
    const firstPart = `localstock`;
    return {
      searchReceipts: `${firstPart}/receipts`,
      plannedReceipts: !id ? `${firstPart}/plannedReceipts` : !actionMode ? `${firstPart}/plannedReceipts/${id}` : `${firstPart}/plannedReceipts/${id}/${actionMode}`,
      storedPlannedReceipts: `${firstPart}/storedPlannedReceipts/${id}`,
      subsequentDelivery: `${firstPart}/storedPlannedReceipts/${id}/subsequentDelivery`,
      reprintStoredReceipt: `${firstPart}/storedPlannedReceipts/${id}/reprint`,
    }
  },
  localReturnReceipts: (id, actionMode) => {
    const firstPart = `localstock`;
    return {
      searchReturns: `${firstPart}/returns`,
      plannedReturns: !id ? `${firstPart}/returns` : !actionMode ? `${firstPart}/returns/${id}` : `${firstPart}/returns/${id}/${actionMode}`,
      storedReturns: `${firstPart}/storedReturns/${id}`,
      reprintStoredReceipt: `${firstPart}/storedReturns/${id}/reprint`,
    }
  },
  localReceiptPrints:(transactionNo) => {
    const firstPart = `localstock`;
    return {
      printStoredReceipt: `${firstPart}/storedPlannedReceipts/${transactionNo}/print`,
      printStoredReturn: `${firstPart}/storedReturns/${transactionNo}/print`,
    }
  },
  withdrawals: (id, barcode) => {
    const firstPart = `localstock`;
    return {
      search: `${firstPart}/withdrawals`,
      shippingOrders: `${firstPart}/withdrawals/shippingOrders/${id}`,
      pickingPreparation: `${firstPart}/withdrawals/shippingOrders/${id}/pickingPreparation`,
      pickingControl: `${firstPart}/withdrawals/shippingOrders/${id}/pickingControl`,
      hasBeenPicked: `${firstPart}/withdrawals/shippingOrders/${id}/hasBeenPicked`,
      pickingStarted: `${firstPart}/withdrawals/shippingOrders/${id}/pickingStarted`,
      resetShippingOrders: `${firstPart}/withdrawals/shippingOrders/${id}/resetPickingProcess`,
      printPickinglist: `${firstPart}/withdrawals/shippingOrders/${id}/prints/pickinglist`,
      printPackagelabel: `${firstPart}/withdrawals/shippingOrders/${id}/prints/packagelabel`,
      printDeliverySlip: `${firstPart}/withdrawals/shippingOrders/${id}/prints/deliverySlip`,
      changeStorehouse: `${firstPart}/withdrawals/shippingOrders/${id}/changeStorehouse`,
      unlockShippingOrder: `${firstPart}/withdrawals/shippingOrders/${id}/unlock`,
      stealLockShippingOrder: `${firstPart}/withdrawals/shippingOrders/${id}/stealLock`,
      lockShippingOrder: `${firstPart}/withdrawals/shippingOrders/${id}/lock`,
      scanArticle: `${firstPart}/withdrawals/shippingOrders/${id}/scan/${barcode}`,
    }
  },
  units:'units',
  articleAdmin: (articleId, sizeSystemId, sizeId) => {
    const firstPart = `administration/articles`;
    if (!articleId) {
      return firstPart
    }
    return {
      article: `${firstPart}/${articleId}`,  // GET, POST, DELETE 
      officeAvailabilities: `${firstPart}/${articleId}/officeAvailabilities`,  // GET, POST 
      copyArticle: `${firstPart}/${articleId}/copy`,  // GET, POST
      sizeSystems: `${firstPart}/${articleId}/sizeSystems`,  // GET, POST
      sizeSystemsOrderSequences: `${firstPart}/${articleId}/sizeSystems/ordersequences`,  // PUT
      sizeSystem: `${firstPart}/${articleId}/sizeSystems/${sizeSystemId}`,  // GET, POST, DELETE 
      sizes: `${firstPart}/${articleId}/sizeSystems/${sizeSystemId}/sizes`,  // GET
      sizesOrderSequences: `${firstPart}/${articleId}/sizeSystems/${sizeSystemId}/sizes/ordersequences`,  // PUT
      createSize: `${firstPart}/${articleId}/sizeSystems/${sizeSystemId}/sizes`,  // POST
      size: `${firstPart}/${articleId}/sizeSystems/${sizeSystemId}/sizes/${sizeId}`,  // GET, PATCH, DELETE 
      documents: `${firstPart}/${articleId}/documents`,  // GET, POST
    }
  },
  articleAdminSupplierAlias : (id, supplierId) => `administration/articles/${id}/supplierAlias/${supplierId}`,
  articleAdminDispoSettings : (id, procGroupId) => `administration/articles/${id}/dispoSettings/${procGroupId}`,
  uploadDocumentsAdmin:'administration/uploadDocuments',
  uploadOGISDocumentsAdmin:'administration/uploadOGISDocuments',
  documentAdmin: (id) => {
    const firstPart = `administration/documents`;
    if (!id) {
      return firstPart
    }
    return {
      documents: `${firstPart}/${id}`,  // GET, POST, DELETE 
      reactivate: `${firstPart}/${id}/reactivate`,  //POST 
      history: `${firstPart}/${id}/history`,  // GET
    }
  },
  assetGroups : 'assetgroups',
  assetGroup : id => `assetgroups/${id}`,
  assetGroupAdmin: (id) => {
    const firstPart = `administration/assetgroups`;
    if (!id) {
      return firstPart
    }
    return {
      group: `${firstPart}/${id}`,  // GET, POST, DELETE 
      addresses: `${firstPart}/${id}/addresses`,  // GET, POST 
    }
  },
  assets: (id) => {
    const firstPart = `assets`;
    if (!id) {
      return firstPart
    }
    return {
      fullData: `${firstPart}/${id}`,  // GET, POST, DELETE 
      activities: `${firstPart}/${id}/activities`,  // GET 
      mainData: `${firstPart}/${id}/mainData`,  // GET 
      info: `${firstPart}/${id}/info`,  // GET 
    }
  },
  object: (objectId) => {
    const firstPart = `objects/${objectId}`
    return {
      documents: `${firstPart}/documents`,
      threads: `${firstPart}/threads`,
    }
  },
}
let result = { APIBaseUrl, APIBaseUrlToken, APIBaseUrlEndpoints, APIEndpoints, AuthorizationserverTokenUrl }
export default result
